var styles = {"box":"RewardsList_box_dmb3p_1"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
